import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {injectIntl} from 'react-intl';

import * as types from '../types/index';

import SocialButton from '../components/SocialButton';
import CustomScrollbars from '../components/CustomScrollbars';
import AppBlock from '../components/AppBlock';
import Footer, {bindPaths, PATHS} from '../components/Footer';
import {PushEvent} from '../utils/googleTagManager';
import Title from '../components/Form/Title';
import {pathByLabel} from '../utils/urlPaths';

class OtherSocials extends Component {
  // eslint-disable-next-line class-methods-use-this
  componentDidMount() {
    PushEvent('Other socials');
  }

  componentWillUnmount() {
    this.props.dispatch({type: types.SEARCH_AUTH_TYPE, text: ''});
  }

  onSearchChange(e) {
    this.props.dispatch({type: types.SEARCH_AUTH_TYPE, text: e.target.value});
  }

  render() {
    const {
      xl: {compactView},
      route: {onlySocials},
      intl
    } = this.props;

    const backURL = {
      pathname: onlySocials
        ? pathByLabel[PATHS.LOGIN_BY_SOCIALS]
        : pathByLabel[PATHS.LOGIN_BY_USERNAME],
      search: this.props.location.search
    };

    const customScrollbarsHeight = compactView ? '100%' : 'calc(100% - 50px)';

    const blockContentModifier = compactView ? 'fixed-height' : 'full-height';

    return (
      <React.Fragment>
        <AppBlock>
          <Title
            className="with-input"
            backLink={
              <Link className="back-link" to={backURL}>
                {intl.messages['app.back']}
              </Link>
            }
          >
            <div className="form-group right-align">
              <input
                type="text"
                maxLength="30"
                autoComplete="off"
                name="search"
                placeholder={intl.messages['form.search']}
                className="form-input"
                onChange={this.onSearchChange.bind(this)}
              />
              <div className="input-icon icon-search" />
            </div>
          </Title>

          <div className={`block-content block-content--${blockContentModifier}`}>
            {this.props.filteredItems.length === 0 && this.props.searchFieldValue.length > 0 ? (
              <div className="content-message">
                <div className="message">
                  {intl.messages['socials.not-found']}
                  <br /> &quot;
                  {this.props.searchFieldValue}
                  &quot;
                </div>
                <Link className="form-button button-with-bg" to={backURL}>
                  {intl.messages['app.back']}
                </Link>
              </div>
            ) : (
              <CustomScrollbars style={{height: customScrollbarsHeight}}>
                <ul className="social-list with-scroll">
                  {this.props.filteredItems.map(item => (
                    <li key={item.name}>
                      <SocialButton
                        name={item.name}
                        label={item.name}
                        url={item.name === 'email' ? backURL : item.url}
                        flat={true}
                      />
                    </li>
                  ))}
                </ul>
              </CustomScrollbars>
            )}
          </div>
        </AppBlock>
        {!onlySocials && <Footer links={bindPaths(PATHS.CREATE_ACCOUNT)} />}
      </React.Fragment>
    );
  }
}

OtherSocials.propTypes = {
  searchFieldValue: PropTypes.string,
  filteredItems: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  intl: PropTypes.object,
  xl: PropTypes.object,
  route: {
    onlySocials: PropTypes.bool
  }
};

function mapStateToProps(state, props) {
  const {socialLinks, searchFieldValue} = state.xl;
  const allSocials = [...socialLinks.primary, ...socialLinks.secondary, ...socialLinks.other];
  if (!props.route.onlySocials) {
    allSocials.push({
      name: 'email'
    });
  }

  const loweredSearchValue = searchFieldValue.toLowerCase();

  return {
    xl: state.xl,
    auth: state.auth,
    searchFieldValue,
    filteredItems: allSocials.filter(item => {
      let localizedName = props.intl.messages[`socials.${item.name}`];
      if (localizedName) {
        localizedName = localizedName.toLowerCase();
      } else {
        localizedName = '';
      }
      const pureName = item.name.toLowerCase();
      return localizedName.includes(loweredSearchValue) || pureName.includes(loweredSearchValue);
    })
  };
}

export default injectIntl(connect(mapStateToProps)(OtherSocials));



// WEBPACK FOOTER //
// ./pages/OtherSocials.jsx